module.exports = __webpack_public_path__ + "static/media/persona2.08c36bd7.webp";